import { SearchAndFilterTypes } from "src/constants";
import { CommonFilterProps } from "../CommonFilters";
import { DateFilter } from "./DateFilter";

const EXPIRES_AT_DATE_FILTER_KEYS = {
  daysAgo: SearchAndFilterTypes.ExpiresAtNextDays,
  dateFrom: SearchAndFilterTypes.ExpiresAtDateFrom,
  dateTo: SearchAndFilterTypes.ExpiresAtDateTo,
};

export const ExpiresAtDateFilter = (props: CommonFilterProps) => {
  return (
    <DateFilter
      label="Expiration date"
      description="Filter by offer expiration date"
      filterKeys={EXPIRES_AT_DATE_FILTER_KEYS}
      direction="future"
      {...props}
    />
  );
};
